import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export function NormalizePhoneToDefaultFormat(phone: string): string {
    let normalizedPhone = ConvertPhoneToE164Format(phone);
    normalizedPhone = normalizedPhone.replace(/\D/g, '');

    return normalizedPhone;
}

export function NormalizePhoneToTikTokFormat(phone: string): string {
    let normalizedPhone = ConvertPhoneToE164Format(phone);

    return normalizedPhone;
}

function ConvertPhoneToE164Format(rawPhoneNumber: string | null) {
    if (!rawPhoneNumber) {
        return '';
    }

    const cleaned = rawPhoneNumber.replace(/\D/g, '');

    let phone = parsePhoneNumberFromString(cleaned);

    if (!phone) {
        phone = parsePhoneNumberFromString(rawPhoneNumber, 'GB');
    }

    if (!phone || !phone.isValid()) {
        phone = parsePhoneNumberFromString(rawPhoneNumber, 'IE');
    }

    // force convert number to GB e.164 format
    if (!phone || !phone.isValid()) {
        return `+44${cleaned.substring(1)}`;
    }

    return phone.format('E.164');
}